import moment, { Moment } from "moment-timezone";
import { add } from "date-fns";
import { timezone } from "expo-localization";
import { number } from "yup";
import holidays from "./data/holidays";

// We may standardize completely to PST but if not, we can use this function to get the
// local time for the user
export const getDisplayableLocalTime = (utcDate: Date | Moment) => {
  const timezoneAwareMomentDate = moment(utcDate).tz(timezone);
  // Will still need to call format in order to get a date the user is happy with
  return timezoneAwareMomentDate;
};

// Pst date means the server returns a value that is "UTC" but we want to consider it as if it were PST
// We solve this by removing the timezone information and letting moment assume it's of the desired timezone
// on would return the utc time but in reality is a pst time
export const convertPstDateIntoLocalTime = (pstDate: Date | Moment) => {
  // Treat the date that is in utc as if it were in pst by "converting it" to pst
  return moment.tz(pstDate, PST_TIMEZONE);
};

export const formatDate = (d: Date | undefined) => d && moment(d).format("MMM DD, yyyy");
export const formatDateDo = (d: Date | undefined) => d && moment(d).format("Do");
// Useful for datePickers and other ui components that don't specify time
export const addStartOfDayInformationWithTimezone = (date: Date, timezone = PST_TIMEZONE) => {
  const month = date.getMonth() + 1;
  const specificDay = date.getDate();
  const dateWithoutTime = [
    date.getFullYear(),
    month < 10 ? `0${month}` : month,
    specificDay < 10 ? `0${specificDay}` : specificDay,
  ].join("-");
  const dateWithTimezoneInformation = moment.tz(dateWithoutTime, timezone);
  return dateWithTimezoneInformation;
};

export const shortDate = (dateString: string) => {
  return moment(new Date(dateString)).format("MM/DD/YYYY");
};

export const PST_TIMEZONE = "America/Los_Angeles";

const getBusinessDayOffset =
  (daysDirection: number) =>
  (daysOffset = 1, dateFrom?: any) => {
    if (daysOffset < 0) {
      throw new Error("daysOffset must be at least 0");
    }
    let current = moment(dateFrom);

    while (!isBusinessDay(current)) {
      current = current.add(daysDirection, "d");
    }

    while (daysOffset > 0) {
      current = current.add(daysDirection, "d");
      if (isBusinessDay(current)) {
        daysOffset--;
      }
    }

    return current;
  };
const isBusinessDay = (momentDate: Moment) =>
  !exports.isWeekend(momentDate) && !exports.isHoliday(momentDate);

export const isWeekday = (momentDate: Moment) => {
  return momentDate.isoWeekday() < 6;
};

export const isWeekend = (momentDate: Moment) => {
  return momentDate.isoWeekday() > 5;
};

export const isHoliday = (momentDate: Moment) => {
  if (momentDate.year() > holidays.max_year || momentDate.year() < holidays.min_year) {
    throw new Error(`holidays data contains date between ${holidays.min_year} and
    ${holidays.max_year} and therefore can't provide a reliable result for the date provided`);
  }
  return momentDate.format(holidays.format) in holidays.list;
};

export const getPrevBusinessDay = getBusinessDayOffset(-1);

export const getNextBusinessDay = getBusinessDayOffset(1);

export const getDifferenceInDays = (startDate: Moment, endDate: Moment) => {
  return Math.abs(endDate.diff(startDate, "days"));
};
